import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./PotItem.module.scss";
import { v4 } from "uuid";
import { CheckBox } from "@mui/icons-material";
import ImageLoader from "./ImageLoader";
const PotItem = ({ data = { "type": "user", "record": false, "tag": "健行", "name": "象山", "lat": 25.0274, "lng": 121.5704, "photo": "./photo/photo1.jpg", "info": "台北市信義區" } }) => {
    useEffect(() => {
        console.log("datadata", data)
    }, [])
    return (
        <div className={style.item}>
            <div className={style.photo}>
                <ImageLoader src={(data.rewilding_photos?.length > 0) ? data.rewilding_photos[0].rewilding_photos_path : ''} />
            </div>
            <div className={style.info}>
                <div className={style.name}>
                    {data.rewilding_name}
                </div>
                <div className={style.desc}>
                    {data.rewilding_location ? data.rewilding_location.join(" ") : ""}
                </div>
            </div>
        </div>
    );
}

export default PotItem;